import { gql } from 'apollo-boost';

const ZIPCODES_AUTOCOMPLETE = gql`
  query zipcodesAutocomplete($matchZipcode: String, $limitResults: Int) {
    zipcodesAutocomplete(matchZipcode: $matchZipcode, limitResults: $limitResults)
  }
`;

export default ZIPCODES_AUTOCOMPLETE;
